import { render, staticRenderFns } from "./ReCaptcha.vue?vue&type=template&id=f661529a&"
import script from "./ReCaptcha.vue?vue&type=script&lang=ts&"
export * from "./ReCaptcha.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports